import React from 'react';
import { Radio } from '@core-ui/radio';
import { useLocalize } from '@core-ui/localization-provider';
import { ReviewRatings } from '@core-ui/review-ratings';
import { styled } from '@core-ui/react-stitch';
import {
  RATING_FACET_ALL_REVIEWED,
  RATING_FACET_OPTION,
} from './localization-tokens';
import { StarRatingFacetProps, StarSize } from './types';

export const StarRatingFacet = ({
  value,
  applied,
  name,
  onChange,
  facetName,
  isMobile,
}: StarRatingFacetProps) => {
  const { localize } = useLocalize();

  const starSize: StarSize = isMobile ? StarSize.large : StarSize.medium;

  const StarRatings = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {value !== '1' ? (
        <React.Fragment>
          <ReviewRatings
            ariaLabel={localize(RATING_FACET_OPTION, { starNumber: value })}
            starRating={Number(value)}
            starSize={starSize}
          />
          <span data-testid="rating-text">
            {name?.replace(/[0-9]/g, '')?.replace('plus', '+')}
          </span>
        </React.Fragment>
      ) : (
        <span data-testid="all-reviewed">
          {localize(RATING_FACET_ALL_REVIEWED)}
        </span>
      )}
    </div>
  );

  const LabelStyle = styled.div`
    label {
      display: flex;
      align-items: center;
    }
  `;

  const deselect = (event: React.MouseEvent<HTMLElement>) => {
    if (applied) {
      onChange({ currentTarget: { checked: false } });
      event.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <LabelStyle onClick={deselect}>
        {/* @ts-ignore [missing id attribute] */}
        <Radio
          checked={applied}
          label={StarRatings}
          name={facetName}
          onChange={onChange}
          styles={{ labelText: { display: 'flex' } }}
        />
      </LabelStyle>
    </React.Fragment>
  );
};
